import { createApi } from '@reduxjs/toolkit/query/react';

import { fetchBaseQuery } from './fetch-base-query';

interface ReportGeneratorData {
  aiInfo: {
    name: string;
    creator: string;
    dateCreated: string;
    organizationName: string;
  };
  controls: {
    [key: string]: {
      value: string;
      risk: string;
      description: string;
    };
  };
}

interface ExecutiveSummary {
  aiInfo: {
    name: string;
    creator: string;
    dateCreated: string;
    organizationName: string;
  };
}

interface Query {
  aiId: number;
  aiModelVersionId: number;
  aiDatasetVersionId: number;
}

export const reportGeneratorApi = createApi({
  reducerPath: 'reportGeneratorApi',
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    getReportGeneratorData: builder.query<ReportGeneratorData, Query>({
      query: ({ aiId, aiModelVersionId, aiDatasetVersionId }) => ({
        url: `/report-generator/${aiId}/${aiModelVersionId}/${aiDatasetVersionId}`,
        method: 'GET',
      }),
    }),

    getExecutiveSummaryData: builder.query<ExecutiveSummary, Query>({
      query: ({ aiId, aiModelVersionId, aiDatasetVersionId }) => ({
        url: `/report-generator/executive-summary/${aiId}`,
        method: 'GET',
      }),
    }),
  }),
});
